module.exports = __webpack_public_path__ + "static/img/服务支持插图.bc47e65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/服务支持插图.png
// module id = 4trn
// module chunks = 0